// extracted by mini-css-extract-plugin
module.exports = {"root":"root-IAcY2","number":"number-1Oqgn","name":"name-2StI_"};